import { render, staticRenderFns } from "./NewStandaloneDialog.vue?vue&type=template&id=0d68e3fb&"
import script from "./NewStandaloneDialog.vue?vue&type=script&lang=ts&"
export * from "./NewStandaloneDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports